export default "__VITE_ASSET__43f61b67__"